import { render, staticRenderFns } from "./footer.html?vue&type=template&id=6cd45bb9&scoped=true&external"
import script from "./footer.js?vue&type=script&lang=js&external"
export * from "./footer.js?vue&type=script&lang=js&external"
import style0 from "./footer.scss?vue&type=style&index=0&id=6cd45bb9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd45bb9",
  null
  
)

export default component.exports